import RainbowHeader from "../../../../src/components/rainbowHeader";
import Header from "../../../../src/components/header";
import * as React from 'react';
export default {
  RainbowHeader,
  Header,
  React
};